import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Bangladeshi National ID generator following Single Responsibility Principle
 */
export class BdGenerator extends BaseGenerator {
  generate(options = {}) {
    const { length = 10 } = options;

    // Generate based on specified length (10, 13, or 17 digits)
    if (![10, 13, 17].includes(length)) {
      throw new Error('Bangladeshi NID length must be 10, 13, or 17 digits');
    }

    if (length === 10) {
      // Old format: 10 digits starting with non-zero
      const firstDigit = this.randomInt(1, 9);
      const remainingDigits = this.randomDigits(9);
      return firstDigit + remainingDigits;
    } else {
      // New format: 13 or 17 digits
      return this.randomDigits(length);
    }
  }
}